import React, { useState } from 'react';
import {useDispatch} from "react-redux";
import { Popover, Tag, Tabs, Button, Row, Space, Typography } from 'antd';
import { EditFilled, CloseOutlined } from '@ant-design/icons';
import { SwatchesPicker, MaterialPicker, SketchPicker } from 'react-color';
import {comparisonActions} from "../../../Store/slices/comparison.slice";

const { TabPane } = Tabs;

const EditableItem = ({ item, color, onRemove }) => {
  const [visiblePopover, setVisiblePopover] = useState(false);
  const dispatch = useDispatch();

  const onUpdateColor = (color, item) => {
      console.log(color);
      dispatch(comparisonActions.updateItemColor({id: item.id, color: color.hex}));
  }



  const content = (
    <div>
        <Row>
            <Space>
                <Typography.Text>{item.label}</Typography.Text>
            </Space>
            <Space>
                <Button onClick={() => onRemove(item.id)} type="text" icon={<CloseOutlined />} danger />
            </Space>
        </Row>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Swatches" key="1">
          <SwatchesPicker color={color} onChangeComplete={(color) => onUpdateColor(color, item)} />
        </TabPane>
        <TabPane tab="Material" key="2">
          <MaterialPicker color={color} onChangeComplete={(color) => onUpdateColor(color, item)} />
        </TabPane>
        <TabPane tab="Sketch" key="3">
          <SketchPicker color={color} onChangeComplete={(color) => onUpdateColor(color, item)} />
        </TabPane>
      </Tabs>
    </div>
  );

  return (
    <Popover
      content={content}
      title="Edit Item"
      trigger="click"
      visible={visiblePopover}
      onVisibleChange={setVisiblePopover}
    >
      <Tag
        bordered={false}
        icon={<EditFilled style={{ color, fontSize: '16px' }} />}
        className={'cursor shadow-sm'}
        style={{
          background: `linear-gradient(to right, ${color} 5px, #fff 5px)`,
          fontSize: '13px',
          color,
          textTransform: 'capitalize',
          border: `none`,
          borderRadius: '4px',
          padding: '3px 12px',
          margin: '5px',
        }}

      >
        {item.label}
      </Tag>
    </Popover>
  );
};

export default EditableItem;
